var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', [_vm.reportType === 'SRF_MAP' ? _c('v-col', [_c('comma-separated-list', {
    attrs: {
      "label": "Excluded Sections",
      "value": _vm.value.excluded_sections,
      "clearable": ""
    },
    on: {
      "input": function ($event) {
        return _vm.updateValue('excluded_sections', $event, _vm.value);
      }
    }
  })], 1) : _vm._e(), ['CERTIFICATION', 'SUMMARY'].includes(_vm.reportType) ? _c('v-col', [_c('v-row', [_c('v-col', [_c('v-text-field', {
    attrs: {
      "label": "Document Number",
      "value": _vm.value.document_number,
      "clearable": ""
    },
    on: {
      "input": function ($event) {
        return _vm.updateValue('document_number', $event, _vm.value);
      }
    }
  })], 1), _c('v-col', [_c('comma-separated-list', {
    attrs: {
      "label": "Excluded Sections",
      "value": _vm.value.excluded_sections,
      "clearable": ""
    },
    on: {
      "input": function ($event) {
        return _vm.updateValue('excluded_sections', $event, _vm.value);
      }
    }
  })], 1), _c('v-col', [_c('v-checkbox', {
    attrs: {
      "label": "Truncated Report",
      "value": _vm.value.truncated_report
    },
    on: {
      "change": function ($event) {
        return _vm.updateValue('truncated_report', $event, _vm.value);
      }
    }
  })], 1)], 1), _c('v-row', [_c('v-col', [_c('textarea-list', {
    attrs: {
      "label": "Design Notes",
      "value": _vm.value.design_notes,
      "auto-grow": "",
      "clearable": "",
      "rows": "1"
    },
    on: {
      "input": function ($event) {
        return _vm.updateValue('design_notes', $event, _vm.value);
      }
    }
  })], 1)], 1)], 1) : _vm._e(), ['DXFS', 'TRAPEZOID_CSV'].includes(_vm.reportType) ? _c('v-col', [_c('v-row', [_c('v-col', [_c('v-checkbox', {
    attrs: {
      "label": "Include Transitions",
      "value": _vm.value.include_transitions
    },
    on: {
      "change": function ($event) {
        return _vm.updateValue('include_transitions', $event, _vm.value);
      }
    }
  })], 1), _c('v-col', [_c('numeric-text-field', {
    attrs: {
      "label": "Sever Spacing",
      "units": "m",
      "placeholder": "0.08",
      "value": _vm.value.sever_spacing
    },
    on: {
      "input": function ($event) {
        return _vm.updateValue('sever_spacing', $event, _vm.value);
      }
    }
  })], 1)], 1), _c('v-row', [_c('v-col', [_c('numeric-text-field', {
    attrs: {
      "label": "Num Lead In Sheets",
      "placeholder": "0",
      "value": _vm.value.num_lead_in_sheets,
      "rules": [_vm.formRules.optionalCountingNumber]
    },
    on: {
      "input": function ($event) {
        return _vm.updateValue('num_lead_in_sheets', $event, _vm.value);
      }
    }
  })], 1), _c('v-col', [_c('numeric-text-field', {
    attrs: {
      "label": "Num Pusher Sheets",
      "placeholder": "0",
      "value": _vm.value.num_pusher_sheets,
      "rules": [_vm.formRules.optionalCountingNumber]
    },
    on: {
      "input": function ($event) {
        return _vm.updateValue('num_pusher_sheets', $event, _vm.value);
      }
    }
  })], 1)], 1)], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }